import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMinecraft = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 10,
			width: 12,
			height: 12,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 10,
			width: 12,
			height: 12,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 26,
			width: 12,
			height: 12,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 26,
			width: 12,
			height: 12,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 16h4M16 22v4M26 22v4M32 16h-4",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round",
			opacity: .3
		})
	]
});
export default SvgMinecraft;
